module.exports = __webpack_public_path__ + "img/5.dd5925a2.jpg";